import { render, staticRenderFns } from "./ReceivableAgingReportView.vue?vue&type=template&id=e63720d2&scoped=true"
import script from "./ReceivableAgingReportView.vue?vue&type=script&lang=js"
export * from "./ReceivableAgingReportView.vue?vue&type=script&lang=js"
import style0 from "./ReceivableAgingReportView.vue?vue&type=style&index=0&id=e63720d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63720d2",
  null
  
)

export default component.exports